import { createSlice } from "@reduxjs/toolkit";
import {
  addScore,
  updateScore,
  deleteScores,
  activateDeactivateScore,
  fetchScoreTableColumnNames,
  fetchAllScores,
} from "./thunk";
import { toast } from "react-toastify";

const scoreSlice = createSlice({
  name: "scores", // Changed name to "scores"
  initialState: {
    scores: [], // Changed from subTopics to scores
    tableColumnNames: [], 
    loading: false,
    headerload: false,
    error: null,
  },
  reducers: {
    // Add any score-specific synchronous reducers if needed
  },
  extraReducers: (builder) => {
    builder
      // Fetch Score Table Column Names
      .addCase(fetchScoreTableColumnNames.pending, (state) => {
        state.headerload = true;
        state.error = null;
      })
      .addCase(fetchScoreTableColumnNames.fulfilled, (state, action) => {
        state.headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchScoreTableColumnNames.rejected, (state, action) => {
        state.headerload = false;
        state.error = action.payload;
      })

      // Fetch All Scores
      .addCase(fetchAllScores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllScores.fulfilled, (state, action) => {        
        state.loading = false;
        state.scores = action.payload; // Changed from subTopics to scores
      })
      .addCase(fetchAllScores.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Score
      .addCase(addScore.pending, (state) => {
        state.error = null;
      })
      .addCase(addScore.fulfilled, (state, action) => {
        state.scores.unshift(action.payload); 
      })
      .addCase(addScore.rejected, (state, action) => {
        state.error = action.payload;
      })

      // // Update Score
      .addCase(updateScore.pending, (state) => {
        state.error = null;
      })
      .addCase(updateScore.fulfilled, (state, action) => {
        const updatedScore = action.payload; 
        const index = state.scores.findIndex(s => s.ID === updatedScore.ID); 
        if (index !== -1) {
          state.scores[index] = updatedScore;
        }
      })
      .addCase(updateScore.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Scores
      .addCase(deleteScores.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteScores.fulfilled, (state, action) => {
        const deletedIds = action.payload; 
        state.scores = state.scores.filter((item) => !deletedIds.includes(item.ID));
        state.error = null;
      })
      .addCase(deleteScores.rejected, (state, action) => {
        state.error = action.payload;
      })
      
      // // Activate/Deactivate Score
      // .addCase(activateDeactivateScore.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(activateDeactivateScore.fulfilled, (state, action) => {
      //   const updatedScore = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      //   const index = state.scores.findIndex(s => s.ID === updatedScore?.ID); 
      //   if (index !== -1) {
      //     state.scores[index] = { ...state.scores[index], ...updatedScore };
      //   }
      // })
      // .addCase(activateDeactivateScore.rejected, (state, action) => {
      //   state.error = action.payload;
      // });
  },
});

// export const { anyScoreSpecificSynchronousAction } = scoreSlice.actions;
export default scoreSlice.reducer;
